(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["typewriter-text"] && !Shopify.designMode) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, a), wait);
    };
  }
  function reserveSpaceForTypewriter(sectionEl, typeEl, words) {
    const probe = document.createElement('span');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.whiteSpace = 'pre';
    probe.style.pointerEvents = 'none';
    probe.style.left = '-9999px';
    probe.className = 'typewriter-word';
    sectionEl.appendChild(probe);

    let maxW = 0,
      maxH = 0;

    words.forEach((w) => {
      probe.className = `typewriter-word typewriter-word-${w.blockId}`;
      probe.textContent = w.text || ' ';
      const wpx = Math.ceil(probe.offsetWidth);
      const hpx = Math.ceil(probe.offsetHeight);
      if (wpx > maxW) maxW = wpx;
      if (hpx > maxH) maxH = hpx;
    });

    typeEl.style.display = 'inline-block';
    typeEl.style.minWidth = maxW + 'px';
    typeEl.style.minHeight = maxH + 'px';

    sectionEl.removeChild(probe);
  }
  function initTypewriter(sectionId) {
    const sectionElement = document.querySelector(`.typewriter-text-${sectionId}`);
    if (!sectionElement) return;

    const typewriterElement = sectionElement.querySelector('.typewriter-word');
    const wordsContainer = sectionElement.querySelector('.typewriter-words');
    if (!typewriterElement || !wordsContainer) return;

    const words = Array.from(wordsContainer.children).map((span) => ({
      text: span.dataset.word,
      color: span.style.color,
      blockId: span.dataset.blockId,
    }));
    if (!words.length) return;

    const typingSpeed = parseInt(sectionElement.dataset.typingSpeed, 10) || 100;
    const wordDisplayTime = parseInt(sectionElement.dataset.wordDisplayTime, 10) || 2000;

    const recalc = () => reserveSpaceForTypewriter(sectionElement, typewriterElement, words);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recalc);
    } else {
      recalc();
    }
    window.addEventListener('resize', debounce(recalc, 150));

    let currentWordIndex = 0;
    let currentCharIndex = 0;
    let isDeleting = false;

    const type = () => {
      const currentWord = words[currentWordIndex];

      if (isDeleting) {
        typewriterElement.textContent = currentWord.text.substring(0, currentCharIndex - 1);
        currentCharIndex--;
      } else {
        typewriterElement.textContent = currentWord.text.substring(0, currentCharIndex + 1);
        currentCharIndex++;
      }

      typewriterElement.style.color = currentWord.color;
      typewriterElement.className = `typewriter-word typewriter-word-${currentWord.blockId}`;

      if (currentCharIndex === 0 && isDeleting) {
        typewriterElement.textContent = '\u00A0';
      }

      if (!isDeleting && currentCharIndex === currentWord.text.length) {
        isDeleting = true;
        setTimeout(type, wordDisplayTime);
      } else if (isDeleting && currentCharIndex === 0) {
        isDeleting = false;
        currentWordIndex = (currentWordIndex + 1) % words.length;
        setTimeout(type, typingSpeed);
      } else {
        setTimeout(type, typingSpeed);
      }
    };

    typewriterElement.textContent = '';
    type();
  }
  function initializeAllTypewriterSections() {
    const sections = document.querySelectorAll('.typewriter-text');
    sections.forEach((section) => {
      const sectionId = section.getAttribute('data-section-id');
      if (sectionId) {
        initTypewriter(sectionId);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllTypewriterSections);
  } else {
    initializeAllTypewriterSections();
  }
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const sectionId = event.target.querySelector('.typewriter-text')?.getAttribute('data-section-id');
      if (sectionId) {
        initTypewriter(sectionId);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-text"] && !Shopify.designMode) return;
  try {
    
  function WaveText() {
    const textPath = document.querySelector('#text-path');
    const textContainer = document.querySelector('#text-container');
    const path = document.querySelector(textPath.getAttribute('href'));
    const pathLength = path.getTotalLength();
    let lastOffset = pathLength;

    function updateTextPathOffset(offset) {
      textPath.setAttribute('startOffset', offset);
    }

    updateTextPathOffset(pathLength);

    function onScroll() {
      requestAnimationFrame(() => {
        const rect = textContainer.getBoundingClientRect();
        const threshold = 0.2;
        const scrollPercent = (rect.y - window.innerHeight * threshold) / window.innerHeight;
        const newOffset = scrollPercent * 1.1 * pathLength;

        if (Math.abs(newOffset - lastOffset) > 1) {
          updateTextPathOffset(newOffset);
          lastOffset = newOffset;
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  WaveText();

  document.addEventListener('shopify:section:load', (e) => {
    WaveText();
  });

  } catch(e) { console.error(e); }
})();
})();
